export enum FeatureFlags {
  EnableEncryption = 'enable-pro-encryption',
  SampleFeature = 'sample-feature',
}
